import gql from "graphql-tag";
import { ITEM } from "./useInventory";
import { useMutation } from "@apollo/client";
import { Store } from "../store";
import useNotification from "../hooks/useNotification";

const useWantlist = () => {
  const { session } = Store.useState(s => s);
  const { addNotification } = useNotification();

  const [addToWantlist] = useMutation(POST_WANT);

  const handleAddToWantlist = (item) => {
    if (!item) return;
    if (!session)
      return addNotification({ ok: 0, message: "Please login to your account" });
    addToWantlist({ variables: { id: item.id } });
    addNotification({ ok: 1, message: `Item ${!item.wanted ? "added to" : "removed from"} wantlist` });
  };

  return { addToWantlist: handleAddToWantlist };
};

export const POST_WANT = gql(`
  mutation($id: Float!) {
    want(id: $id) {
      ${ITEM}
    }
  }
`);

export default useWantlist;
